import firebase from 'firebase/app';
import 'firebase/firestore';
import axios from 'axios';
import store from '@/store';

// Initialize Firebase
const fstore = {
  // Make all your firebase configurations here
  config: {
    apiKey: 'AIzaSyDoiRZlqH-FD-fMadrevTxoTQ2Vuex7etw',
    authDomain: 'queens-marque-e2367.firebaseapp.com',
    databaseURL: 'https://queens-marque-e2367.firebaseio.com',
    projectId: 'queens-marque-e2367',
    storageBucket: 'queens-marque-e2367.appspot.com',
    messagingSenderId: '317575799065'
  },

  // The pointer that will be add the analytics
  db: null,

  // The user's location
  location: null,

  // Where they came from
  referrer: document.referrer,

  // Initialize Firebase/Firestore
  init() {
    firebase.initializeApp(this.config);
    this.db = firebase.firestore();
    // Get location for rest of analytics
    this.getLocation();

    // Track session after 20 seconds
    setTimeout(() => {
      this.trackSession();
    }, 20000, this);
  },

  // Get user's location
  getLocation() {
    const apiUrl = 'https://api.ipdata.co/?api-key=1f4559c216740f66a3a74ce554e5ab3db3281d32a835de80fbcb11f3';
    axios.get(apiUrl)
      .then((res) => {
        this.location = {
          city: res.data.city,
          province: res.data.region,
          ip: res.data.ip
        };
      });
  },

  // Track floor plan view
  /* Data fields for plan
    plan = {
      name: String, // floor plan name
      interior: Number, // interior sqft
      type: String, // one, oneDen, two, etc.
      beds: Number, // number of bedrooms
      den: Boolean,
      baths: Number,
      exposures: [String], // ex. ['n', 'e']
    };
  */
  trackPlanView(plan) {
    this.db.collection('analytics').add({
      projectId: store.state.project.awsId,
      action: 'FloorplanViewed',
      data: {
        ...plan,
        geolocation: this.location,
        agent: store.state.user.agent
      },
      createdAt: firebase.firestore.Timestamp.now()
    });
  },

  // Track email floor plan
  // Fields are same as above
  trackPlansConverted(plans) {
    if (!plans.length) {
      return;
    }
    const batch = this.db.batch();
    plans.forEach((plan) => {
      const planRef = this.db.collection('analytics').doc();
      batch.set(planRef, {
        projectId: store.state.project.awsId,
        action: 'FloorplanConverted',
        data: {
          ...plan,
          geolocation: this.location,
          agent: store.state.user.agent
        },
        createdAt: firebase.firestore.Timestamp.now()
      });
    });

    batch.commit()
      .catch((err) => { console.err(err); });
  },

  // Track leads when someone emails floor plan
  trackLeads(email, plans) {
    if (!plans.length) {
      return;
    }
    console.log(email, plans);
    this.db.collection('analytics').add({
      projectId: store.state.project.awsId,
      action: 'LeadsTracked',
      data: {
        email,
        plans: plans.map(plan => plan.name)
      },
      createdAt: firebase.firestore.Timestamp.now()
    });
  },

  // Track unit viewed
  /* Data fields for unit
    unit = {
      floor: Number,
      exposures: [String]
    };
  */
  trackUnitViewed(unit) {
    this.db.collection('analytics').add({
      projectId: store.state.project.awsId,
      action: 'UnitViewed',
      data: { ...unit },
      createdAt: firebase.firestore.Timestamp.now()
    });
  },

  // Track session
  trackSession() {
    this.db.collection('analytics').add({
      projectId: store.state.project.awsId,
      action: 'SessionTracked',
      data: {
        geolocation: this.location,
        referrer: this.referrer,
        agent: store.state.user.agent
      },
      createdAt: firebase.firestore.Timestamp.now()
    });
  },

  // Track agent login
  trackAgentLogin() {
    setTimeout(() => {
      this.db.collection('analytics').add({
        projectId: store.state.project.awsId,
        action: 'AgentLogin',
        data: store.state.user.agent,
        createdAt: firebase.firestore.Timestamp.now()
      });
    }, 1000, this);
  }
};

export default fstore;



// WEBPACK FOOTER //
// ./src/analytics/firestore.js